module.exports = __webpack_public_path__ + "static/media/SmartShop_7-432w.ef0f0f85.webp";